import { useSyncExternalStore } from 'react'
import {
  getDesignPreviewProjectId,
  getDesignPreviewProjects,
  subscribeDesignPreviewProjectId,
  subscribeDesignPreviewProjects,
} from './designPreviewProjectStore.part01.js'

/** @returns {import('@/components/DocumentPreview/designPreviewProjectOptions').DesignPreviewProjectOption[]} */
export function useDesignPreviewProjects() {
  return useSyncExternalStore(subscribeDesignPreviewProjects, getDesignPreviewProjects)
}

/** @returns {string} */
export function useDesignPreviewProjectId() {
  return useSyncExternalStore(subscribeDesignPreviewProjectId, getDesignPreviewProjectId)
}

/** @param {string} projectId */
export function getDesignPreviewProjectOption(projectId) {
  const projects = getDesignPreviewProjects()
  return projects.find((project) => project.id === projectId) ?? projects[0]
}
